import { redirect } from '@sveltejs/kit';
import type { PageLoad } from './$types';

export const load: PageLoad = async ({ params, parent }) => {
	const { balancedSupabase } = await parent();
	const { data: sector, error } = await balancedSupabase
		.from('video_sectors')
		.select('*')
		.eq('slug', params.sectorSlug)
		.single();
	if (error) {
		console.error(error);
		return redirect(307, '/videos');
	}
	return {
		sector
	};

	// redirect(307, `/videos?sector=${sector.id}`);
};
